import { Injectable } from '@angular/core';
import { WorkflowLevelAutomationResources } from './workflow-level-automation.resources';

@Injectable({ providedIn: 'root' })
export class WorkflowLevelAdvancementResources extends WorkflowLevelAutomationResources {
  protected apiBase = '/api/manager/WorkflowLevelRoutingAutomation';
  protected searchHistoryRuleSetParam = 'WorkflowLevelRoutingAutomationRuleSetId';

}
